import script from "./type_bodycam.vue?vue&type=script&setup=true&lang=js"
export * from "./type_bodycam.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__